import { useTranslation } from "react-i18next";
import PageContainer from "../../components/PageContainer";

const LessonsPage = () => {
  const { t } = useTranslation();
  return <PageContainer header={t("page.lessons")}></PageContainer>;
};

export default LessonsPage;
